import React from 'react';
import AnimatedNumber from './AnimatedNumber';
import './KpiCard.css';

function KpiCard({ label, value, sub, icon, tone = 'primary', delta, deltaDir }) {
  return (
    <div className={`kpi-card kpi-${tone}`}>
      {icon && <div className="kpi-icon">{icon}</div>}
      <div className="kpi-body">
        <div className="kpi-label">{label}</div>
        <div className="kpi-value"><AnimatedNumber value={value} /></div>
        {delta != null && (
          <div className={`kpi-delta kpi-delta--${deltaDir || 'up'}`}>{delta}</div>
        )}
        {sub && <div className="kpi-sub">{sub}</div>}
      </div>
    </div>
  );
}

export default KpiCard;
